angular.module('rjmNg.constants')
.constant('figureEnums',
  DATA_PERSPECTIVES: Object.freeze                                                        # v1.0C | v1.0S | v0.1 # C - Cohort, S - Standard
    standard: 'Standard'                                                                  #   *   |   *   |   *
    cumulative: 'Cumulative'                                                              #       |   *   |   *
    cumulativeCohort: 'Cumulative'                                                        #   *   |       |
    amountVsPreviousPeriod: 'Amount Change vs Previous Period'                            #       |   *   |   *
    amountVsPreviousYear: 'Amount Change vs Previous Year'                                #       |   *   |   *
    percentVsPreviousPeriod: 'Percent Change vs Previous Period'                          #       |   *   |   *
    percentVsPreviousYear: 'Percent Change vs Previous Year'                              #       |   *   |   *
    percentOfFirstValueShowFirstValue: 'Percent Of First Value (Show First Value)'        #       |   *   |   *
    percentOfFirstValueShowFirstValueCohort: 'Percent Of First Value (Show First Value)'  #   *   |       |
    percentOfFirstValueHideFirstValueCohort: 'Percent Of First Value (Hide First Value)'  #   *   |       |
    percentOfFirstValueHideFirstValue: 'Percent Of First Value (Hide First Value)'        #       |       |   *
    cumulativeAverageValuePerCohortMember: 'Cumulative Average Value Per Cohort Member'   #   *   |       |
    averageValuePerCohortMember: 'Average Value Per Cohort Member'                        #   *   |       |
    rollingAverage: 'Rolling Average Window'                                              #       |   *   |

  CHART_TYPES: Object.freeze
    line: "Line"
    bar: "Bar"
    barstacked: "Stacked Bar"
    column: "Column"
    columnstacked: "Stacked Column"
    pie: "Pie"
    area: "Area"
    funnel: "Funnel"
    scatter: "Plotted Points"
    heatmap: "Heatmap Table"

  SQL_CHART_TYPES: Object.freeze
    line: "Line"
    bar: "Bar"
    barstacked: "Stacked Bar"
    column: "Column"
    columnstacked: "Stacked Column"
    pie: "Pie"
    area: "Area"
    funnel: "Funnel"

  COHORT_CHART_TYPES: Object.freeze
    line: "Line"
    area: "Area"

  PRESENTATION_TYPES: Object.freeze
    HIGHCHARTS: 1
    TABLE: 2
    SCALAR: 3

  PERSPECTIVE_CONSTANTS: Object.freeze
    DEFAULT_AVERAGE_WINDOW_LENGTH: 7

  WARNING_CODES: Object.freeze
    COMPOSITE_SORT: 1000
    DATA_TRUNCATED: 1001
    IS_STALE: 1002
    CACHE_IN_PROGRESS: 1003
    GA_DATA_TRUNCATED: 1004

  WARNING_MESSAGES: Object.freeze
    1001: "You have exceeded the 3500 data point limit.  As a result, this limit will cause blank values in this report. Add filters, reduce the time range, or group by a larger time interval to reduce the number of data points, or export the data to view them all."

  ERROR_CODES: Object.freeze
    DUPLICATE_NAME: 2000
    INVALID_RJQL_QUERY: 2001
    RJQL_QUERY_TOO_LONG: 2002

  PERCENT_Y_AXIS_SCALING: Object.freeze
    LOWER_THRESHOLD: 0.95
    UPPER_THRESHOLD: 1 + 0.005

)